import { put, select } from 'redux-saga/effects';
import { EVerifyPhoneError, TVerifyPhoneStart, verifyPhoneSetErrorMessageAction } from '@cian/sms-validation-widget';
import { demandLastRequestedData, demandRequestCreateMessageStartAction } from '@cian/demand-trap-widget';
import { trackVerificationPhoneError, trackVerifyPhone } from '../../utils/demand/trackDemandEvents';
import { getTotalPages } from '../helpers/getTotalPagesSaga';

export function* verifyPhoneRequestSagas({ payload }: TVerifyPhoneStart) {
  const lastRequestedDemandData = yield select(demandLastRequestedData);
  const totalPages = yield getTotalPages();

  trackVerifyPhone(Boolean(lastRequestedDemandData.isHomeowner), totalPages);

  if (!payload) {
    trackVerificationPhoneError(Boolean(lastRequestedDemandData.isHomeowner), totalPages);
    yield put(verifyPhoneSetErrorMessageAction(EVerifyPhoneError.NOT_CORRECT));
  } else {
    yield put(demandRequestCreateMessageStartAction({ ...lastRequestedDemandData, confirmationCode: payload }));
  }
}
